import Breadcrumbs from '../components/Breadcrumbs';
import Link from '../components/Link';
import { CONTENT_CLASSES } from '../constants/classNames';
import { CONTACT_EMAIL, ROUTES, SITE_NAME } from '../constants/config';
import '../styles/ContentPage.css';

const TERMS_UPDATED = '30 September 2026';

/**
 * Terms of use: it's a pretend lab, don't try real reactions at home, and what we own.
 */
export default function TermsPage() {
  return (
    <article className={CONTENT_CLASSES.root}>
      <Breadcrumbs
        trail={[
          { label: 'Lab', path: ROUTES.LAB },
          { label: 'Terms of use', path: ROUTES.TERMS },
        ]}
      />
      <header className={CONTENT_CLASSES.hero}>
        <h1 className={CONTENT_CLASSES.heading}>Terms of use</h1>
        <p className={CONTENT_CLASSES.meta}>Last updated: {TERMS_UPDATED}</p>
        <p className={CONTENT_CLASSES.lead}>
          By using {SITE_NAME} you agree to these simple rules. If you're a child, please read them with a grown-up.
        </p>
      </header>

      <section className={CONTENT_CLASSES.section}>
        <h2 className={CONTENT_CLASSES.sectionTitle}>It's a pretend lab</h2>
        <p className={CONTENT_CLASSES.text}>
          Everything in the {SITE_NAME} lab is a simulation for learning. Never try these reactions for real. Many of
          the substances shown are poisonous, explosive, radioactive or burn skin, and real chemistry must only be
          done by trained people in a proper lab with safety equipment.
        </p>
      </section>

      <section className={CONTENT_CLASSES.section}>
        <h2 className={CONTENT_CLASSES.sectionTitle}>Accuracy</h2>
        <p className={CONTENT_CLASSES.text}>
          We work hard to keep the science correct and simple, but reactions are simplified for young learners and
          real results depend on amounts, temperature and conditions. {SITE_NAME} is provided "as is", without
          warranties. If you spot a mistake, please <Link to={ROUTES.CONTACT}>tell us</Link>.
        </p>
      </section>

      <section className={CONTENT_CLASSES.section}>
        <h2 className={CONTENT_CLASSES.sectionTitle}>Our content</h2>
        <p className={CONTENT_CLASSES.text}>
          The drawings, Fizzy the kid scientist, the explanations and the voice recordings on {SITE_NAME} belong to
          us. You're welcome to use the site at home and in classrooms, but please don't copy or republish our
          content without asking.
        </p>
      </section>

      <section className={CONTENT_CLASSES.section}>
        <h2 className={CONTENT_CLASSES.sectionTitle}>Contact</h2>
        <p className={CONTENT_CLASSES.text}>
          Questions about these terms? Email <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      </section>
    </article>
  );
}
